
import { AchivementConditions } from "../Enums/GameEnums";

export interface ProgressData {
    name: string;
    condition?: AchivementConditions;
    count: number
    secondCount?: number
    thirdCounter?: number
}


// most of these functions can and should be optimised and refactored, just for now we need to start logging and tracking as much data as possible to not have players loose too much progress


export function addKilledProgress(state, isPlayer: boolean) {
    const progressData = state.progressData;
    let monsterExists = false;
    const condition = isPlayer? AchivementConditions.KILLED: AchivementConditions.KILLED_BY
    const monsterName = state.monster.name;
    if (progressData.length > 0) {
        progressData.forEach(data => {
            if (data.name === monsterName && data.condition === condition) {
                data.count = data.count + 1;
                monsterExists = true;
            }
        });
        if (monsterExists === false) {
            progressData.push({
                name: monsterName,
                condition: condition,
                counter: 1
            })
        }
    } else {
        progressData.push({
            name: monsterName,
            condition: condition,
            counter: 1
        })
    }
    return progressData;
}

export function addLevelEndProgress(state) {
    const locationName = state.levelName;
    const progressData = state.progressData;
    const currentLevel = state.level;
    const maxLevelString = 'maxLevel';
    let locationExists = false;
    let maxLevelExists = false;
    if (progressData.length > 0) {
        progressData.forEach(data => {
            if (data.name === locationName && data.condition === AchivementConditions.KILLED) {
                data.count = data.count + 1;
                locationExists = true;
            }
            if (data.name === maxLevelString) {
                if (currentLevel > data.counter) data.counter = currentLevel;
                maxLevelExists = true;
            }
        });

        if (locationExists === false) {
            progressData.push({
                name: locationName,
                condition: AchivementConditions.BEATEN,
                counter: 1
            })
        }
        if (maxLevelExists === false) {
            progressData.push({
                name: maxLevelString,
                condition: AchivementConditions.REACHED,
                counter: currentLevel
            })
        }
    } else {
        progressData.push({
            name: locationName,
            condition: AchivementConditions.BEATEN,
            counter: 1
        })
        progressData.push({
            name: maxLevelString,
            condition: AchivementConditions.REACHED,
            counter: currentLevel
        })
    }
    return progressData;
}
export function addBetProgress(state) {
    const bet = state.bet;
    const progressData = state.progressData;
    let betExits = false;
    const betName = 'averageBet';
    if (progressData.length > 0) {
        progressData.forEach(data => {
            if (data.name === betName && data.condition === AchivementConditions.AVERAGE) {
                data.count = data.count + bet;
                data.secondCount = data.secondCount + 1;
                betExits = true;
            }
        });
        if (betExits === false) {
            progressData.push({
                name: betName,
                condition: AchivementConditions.AVERAGE,
                count: bet,
                secondCount: 1
            })
        }
    } else {
        progressData.push({
            name: betName,
            condition: AchivementConditions.AVERAGE,
            count: bet,
            secondCount: 1
        })
    }
    return progressData;
}
export function addHealthPotionProgress(state) {
    const progressData = state.progressData;
    let healthPotExists = false;
    const healthPointName = 'healthPotionUsed';
    if (progressData.length > 0) {
        progressData.forEach(data => {
            if (data.name === healthPointName && data.condition === AchivementConditions.USED) {
                data.count = data.count + 1;
                healthPotExists = true;
            }
        });
        if (healthPotExists === false) {
            progressData.push({
                name: healthPointName,
                condition: AchivementConditions.USED,
                count: 1
            })
        }
    } else {
        progressData.push({
            name: healthPointName,
            condition: AchivementConditions.USED,
            count: 1
        })
    }
    return progressData;
}

export function addBlackJackProgress(state, damage: number, isPlayer: boolean) {
    const progressData = state.progressData;
    let bjExists = false;
    const condition = isPlayer? AchivementConditions.GIVEN: AchivementConditions.TAKEN
    const blackJackName = 'blackJackDamage';
    if (progressData.length > 0) {
        progressData.forEach(data => {
            if (data.name === blackJackName && data.condition === condition) {
                data.count = data.count + 1;
                data.secondCount = data.secondCount + damage
                bjExists = true;
            }
        });
        if (bjExists === false) {
            progressData.push({
                name: blackJackName,
                condition: condition,
                count: 1,
                secondCount: damage
            })
        }
    } else {
        progressData.push({
            name: blackJackName,
            condition: condition,
            count: 1,
            secondCount: damage
        })
    }
    return progressData;
}

export function addDamageBlocked(state, damage: number, totallyNegated: boolean, isPlayer: boolean) {
    const progressData = state.progressData;
    const condition = isPlayer? AchivementConditions.TAKEN: AchivementConditions.GIVEN
    let damageExists = false;
    const damageBlockedName = 'negatedDamage';
    if (progressData.length > 0) {
        progressData.forEach(data => {
            if (data.name === damageBlockedName && data.condition === condition) {
                data.count = totallyNegated? data.count + 1: data.count; // counts how many hits were totally blocked
                data.secondCount = data.secondCount + damage // total damage it was blocked
                data.thirdCounter = data.thirdCounter > damage? data.thirdCounter: damage; //highest damage blocked
                damageExists = true;
            }
        });
        if (damageExists === false) {
            progressData.push({
                name: damageBlockedName,
                condition: condition,
                count: totallyNegated? 1: 0,
                secondCount: damage,
                thirdCounter: damage
            })
        }
    } else {
        progressData.push({
            name: damageBlockedName,
            condition: condition,
            count: totallyNegated? 1: 0,
            secondCount: damage,
            thirdCounter: damage
        })
    }
    return progressData;
}
